export const passwordRulesMockData = [
	{ id: 'Numeric', message: 'One numeric character' },
	{ id: 'SpecialChar', message: 'One special character (example: ! @ # $ %)' },
	{ id: 'Length', message: 'A minimum of 8 characters' },
	{ id: 'LowerCase', message: 'One lowercase letter' },
	{ id: 'UpperCase', message: 'One uppercase letter' },
	{
		id: 'CharacterRepeat',
		message: 'No more than 4 consecutive repeated characters',
	},
	{ id: 'AllowUsernameMatch', message: 'Must not match username' },
];

export const serverValidationErrorsMockData = {
	Length: 'Please enter a valid password.',
	Numeric: 'Please enter a valid password.',
	SpecialChar: 'Please enter a valid password.',
	UpperCase: 'Please enter a valid password.',
};

export const securityQuestionsMockData = [
	{
		id: '1',
		securityQuestion: `First car's make and model?`,
	},
	{
		id: '2',
		securityQuestion: 'Favorite place to travel?',
	},
	{
		id: '3',
		securityQuestion: `First pet's name?`,
	},
	{
		id: '4',
		securityQuestion: `Best man/Maid of honor's name?`,
	},
	{
		id: '5',
		securityQuestion: 'City where you met your spouse?',
	},
	{
		id: '6',
		securityQuestion: 'Favorite hobby?',
	},
];

export const usernameRulesMockData = {
	usernameValidationRules: [
		{
			id: 'Alphanumeric',
			value: 'Alphanumeric characters only (A-Z, 0-9)',
		},
		{ id: 'MaximumLength', value: 'Must not exceed 15 characters' },
		{ id: 'MinimumLength', value: 'A minimum of 5 characters' },
		{ id: 'Unique', value: 'Must be unique' },
	],
};

export const mockStepOneToken = {
	token: "abcd.sdada.wqwerrwe"
};

export const stepOneMockedResponse = {
	firstName: "Thomas",
	lastName: "Johnson",
	dateOfBirth: "1981-08-01",
}
export const stepTwoMockedResponse = {
	// jwt token format
		token:"abcd.sdada.wqwerrwe", 
		status:"valid | invalid | alreadyExist | requiredMoreInfo | existingEmail",
		memberInfo: {
			// unique identifier for mapping member creation
			// only for sub-account to display in step 2 of registration
			email: "tomjohn@tj.com", 
			clinicName: "St. Vincent's Hospital Outpatient PT",
			clinicAddress: {
			address1: "1124 Oak St.",
			address2: null,
			city: "San Diego",
			state: "CA",
			zip: "92127"
			   }
		} 
}
